var e = /* @__PURE__ */ ((r) => (r.CENTER = "center", r.TOP = "top", r))(e || {});
export {
  e as RocheUIDialogPosition
};
